const useIntercom = () => {
    const help = () => {
        if (window.Intercom) {
            window.Intercom('showSpace', 'help');
        }
    };

    const open = () => {
        if (window.Intercom) {
            window.Intercom('show');
        }
    };

    const contactSupport = (prefilledMessage?: string) => {
        if (window.Intercom) {
            // Intercom prefills the composer when a string is passed to showNewMessage.
            window.Intercom('showNewMessage', prefilledMessage ?? '');
        }
    };

    const shutdown = () => {
        if (window.Intercom) {
            window.Intercom('shutdown');
        }
    };

    return { open, help, contactSupport, shutdown };
};

export default useIntercom;
